import { Icon } from '@fcom/dapi/api/models/icon';

export interface Tag {
  text?: string;
  textKey?: string;
  icon?: Icon;
  theme?: ThemeEnum;
  roundingStyle?: RoundingStyleEnum;
  iconPosition?: IconPositionEnum;
  visible: boolean;
}

export type ThemeEnum = 'default' | 'active' | 'white' | 'sustainability' | 'success' | 'warning' | 'alert' | 'popular';
export const ThemeEnum = {
  Default: 'default' as ThemeEnum,
  Active: 'active' as ThemeEnum,
  White: 'white' as ThemeEnum,
  Sustainability: 'sustainability' as ThemeEnum,
  Success: 'success' as ThemeEnum,
  Warning: 'warning' as ThemeEnum,
  Alert: 'alert' as ThemeEnum,
  Popular: 'popular' as ThemeEnum,
};
export type RoundingStyleEnum = 'default' | 'chip';
export const RoundingStyleEnum = {
  Default: 'default' as RoundingStyleEnum,
  Chip: 'chip' as RoundingStyleEnum,
};
export type IconPositionEnum = 'left' | 'right';
export const IconPositionEnum = {
  Left: 'left' as IconPositionEnum,
  Right: 'right' as IconPositionEnum,
};

export interface UntranslatedTag {
  badge: Tag | null;
}

export enum BadgeType {
  forBusiness = 'forBusiness',
  campaign = 'campaign',
}

export const badgeTypes: Record<BadgeType, UntranslatedTag> = {
  campaign: {
    badge: {
      textKey: 'badges.campaign',
      visible: false,
    },
  },
  forBusiness: {
    badge: {
      visible: true,
      textKey: 'badges.finnairForBusiness',
      icon: {
        name: 'b2b',
        category: 'svg-library',
      },
      theme: 'active',
      roundingStyle: 'default',
      iconPosition: 'left',
    },
  },
};
